// Callout — BlockNote 커스텀 블록. 노션 콜아웃(아이콘 + 둥근 회색 박스).
//
// - props.icon: 좌측 아이콘(이모지). 기본 💡
// - props.bg: 배경색 키(gray/blue/yellow/green/red). 기본 gray
// - content: 'inline' — 박스 안 텍스트는 편집 가능한 인라인 콘텐츠.
//   여러 블록을 담는 리치 콜아웃은 자식 블록 중첩 + CSS(page-editor.css .bn-callout)로 박스 처리.
//
// ⚠️ BlockNote 0.51.4: createReactBlockSpec(config, impl) 는 "생성 함수" 를 반환한다.
//    반드시 끝에 () 로 한 번 더 호출해야 실제 BlockSpec 객체가 된다(LinkedDatabaseView.jsx 참조).
//    누락 시 에디터 초기화 크래시 → 전 페이지 백지.

import { createReactBlockSpec } from '@blocknote/react';

export const calloutSpec = createReactBlockSpec(
  {
    type: 'callout',
    propSchema: {
      icon: { default: '💡' },
      bg: { default: 'gray' },
    },
    content: 'inline',
  },
  {
    render: ({ block, contentRef }) => (
      <div className={'bn-callout bn-callout-' + (block.props.bg || 'gray')}>
        <div className="bn-callout-icon" contentEditable={false}>
          {block.props.icon || '💡'}
        </div>
        <div className="bn-callout-text" ref={contentRef} />
      </div>
    ),
  },
)();

export default calloutSpec;
